"use strict";
// @flow
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signOperation = void 0;
const rxjs_1 = require("rxjs");
const ledger_signer_1 = require("@taquito/ledger-signer");
const taquito_1 = require("@taquito/taquito");
const deviceAccess_1 = require("../../hw/deviceAccess");
const live_env_1 = require("@ledgerhq/live-env");
const errors_1 = require("@ledgerhq/errors");
const modulo_1 = require("../../modulo");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const signOperation = ({ account, deviceId, transaction, }) => (0, deviceAccess_1.withDevice)(deviceId)(transport => rxjs_1.Observable.create(o => {
    let cancelled;
    function main() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const { fees } = transaction;
            if (!fees)
                throw new errors_1.FeeNotLoaded();
            const { freshAddressPath, freshAddress } = account;
            const tezos = new taquito_1.TezosToolkit((0, live_env_1.getEnv)("API_TEZOS_NODE"));
            const ledgerSigner = new ledger_signer_1.LedgerSigner(transport, freshAddressPath, false, ledger_signer_1.DerivationType.ED25519);
            tezos.setProvider({ signer: ledgerSigner });
            // Disable the broadcast because we want to do it in a second phase (broadcast hook)
            // Use a dummy transaction hash, we don't care about this check
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            tezos.contract.context.injector.inject = () => __awaiter(this, void 0, void 0, function* () { return "op4WsnE6gvDPFFzbXtsX1wLCsuAAbkA8JhXKApxvEYmaEd3fpNC"; });
            o.next({ type: "device-signature-requested" });
            let type = "OUT";
            let res, opbytes;
            const params = {
                fee: ((_a = transaction.fees) === null || _a === void 0 ? void 0 : _a.toNumber()) || 0,
                storageLimit: ((_b = transaction.storageLimit) === null || _b === void 0 ? void 0 : _b.toNumber()) || 0,
                gasLimit: ((_c = transaction.gasLimit) === null || _c === void 0 ? void 0 : _c.toNumber()) || 0,
            };
            if (["delegate", "undelegate"].includes(transaction.mode)) {
                // https://ledgerhq.atlassian.net/browse/LL-8821
                params.gasLimit = (0, modulo_1.upperModulo)(transaction.gasLimit || new bignumber_js_1.default(0), new bignumber_js_1.default(136), new bignumber_js_1.default(1000)).toNumber();
            }
            switch (transaction.mode) {
                case "send":
                    res = yield tezos.contract.transfer(Object.assign({ mutez: true, to: transaction.recipient, amount: transaction.amount.toNumber() }, params));
                    opbytes = res.raw.opbytes;
                    break;
                case "delegate":
                    res = yield tezos.contract.setDelegate(Object.assign(Object.assign({}, params), { source: freshAddress, delegate: transaction.recipient }));
                    opbytes = res.raw.opbytes;
                    type = "DELEGATE";
                    break;
                case "undelegate":
                    res = yield tezos.contract.setDelegate(Object.assign(Object.assign({}, params), { source: freshAddress }));
                    opbytes = res.raw.opbytes;
                    type = "UNDELEGATE";
                    break;
                default:
                    throw new Error("not supported");
            }
            if (cancelled) {
                return;
            }
            o.next({ type: "device-signature-granted" });
            // build optimistic operation
            const txHash = ""; // resolved at broadcast time
            const senders = [freshAddress];
            const recipients = [transaction.recipient];
            const accountId = account.id;
            // currently, all mode are always at least one OUT tx on ETH parent
            const operation = {
                id: `${accountId}-${txHash}-${type}`,
                hash: txHash,
                type,
                value: transaction.amount,
                fee: fees,
                extra: {
                    storageLimit: transaction.storageLimit,
                    gasLimit: transaction.gasLimit,
                },
                blockHash: null,
                blockHeight: null,
                senders,
                recipients,
                accountId,
                date: new Date(),
            };
            o.next({
                type: "signed",
                signedOperation: {
                    operation,
                    signature: opbytes,
                    expirationDate: null,
                },
            });
        });
    }
    main().then(() => o.complete(), e => o.error(e));
    return () => {
        cancelled = true;
    };
}));
exports.signOperation = signOperation;
//# sourceMappingURL=signOperation.js.map